import styled from 'styled-components';

import {colors} from 'theme';

export const ScanContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    justify-content: center;
    outline: none;

    & > span {
        font-size: 14px;
        color: ${colors.textSecondary};
        text-align: center;
    }

    & > div:last-child {
        display: grid;
        grid-template-columns: 1fr 100px;
        gap: 10px;
        width: 100%;

        & > button {
            & > span {
                display: flex;
                align-items: center;
                gap: 8px;
            }
        }

        & > * {
            align-self: end;
        }
    }
`;

export const ScanChoose = styled.div`
    display: flex;
    align-items: center;
    gap: 30px;

    & > * {
        cursor: pointer;
        transition: opacity 0.25s ease-in-out;

        &:not(.selected) {
            opacity: 0.5;
        }
    }
`;

export const ScanReadyMessage = styled.span`
    display: grid;
    place-content: center;
    margin: 6px 0;
    color: #0cc778 !important;
`;

export const ScanWarn = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding-top: 16px;
    border-top: 1px solid #e3e3e3;

    & > span {
        color: ${colors.darkGrey};
        text-align: left;
    }
`;
